import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import AdminService from "../../services/admin/admin.services";

const BaskanMesaj = () => {
  const [content, setContent] = useState("");

  useEffect(() => {
    const fetchPresidentMessage = async () => {
      try {
        const response = await AdminService.getPresidentMessage();
        if (response?.result?.data) {
          setContent(response.result.data.content);
        }
      } catch (error) {
        console.error("Error fetching president message:", error);
      }
    };

    fetchPresidentMessage();
  }, []);

  const editorStyle = `
    .p-editor-container .ql-editor h1,
    .p-editor-container .ql-editor h2,
    .p-editor-container .ql-editor h3,
    .p-editor-container .ql-editor h4,
    .p-editor-container .ql-editor h5,
    .p-editor-container .ql-editor h6,
    .preview-content h1,
    .preview-content h2,
    .preview-content h3,
    .preview-content h4,
    .preview-content h5,
    .preview-content h6 {
      color: var(--primary-color);
      margin-bottom: 0.5rem;
      margin-top: 0rem;
    }

    /* Dropdown menülerin arka planı */
    .ql-snow .ql-picker-options {
      background-color: var(--surface-ground) !important;
      border: 1px solid var(--surface-border) !important;
      border-radius: 6px;
      padding: 0.5rem;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    /* Dropdown menü seçenekleri hover efekti */
    .ql-snow .ql-picker-options .ql-picker-item:hover {
      background-color: var(--surface-hover) !important;
      color: var(--primary-color) !important;
    }

    /* Seçili seçeneğin stili */
    .ql-snow .ql-picker-options .ql-selected {
      color: var(--primary-color) !important;
    }

    /* Renk paletinin arka planı */
    .ql-color-picker .ql-picker-options,
    .ql-background .ql-picker-options {
      background-color: var(--surface-ground) !important;
      padding: 0.5rem !important;
    }
  `;

  return (
    <div className="surface-ground flex justify-content-center p-0 md:p-4">
      <style>{editorStyle}</style>
      {/* <Card className="p-1 md:p-4 shadow-2 border-round">
          <h2 className="text-center font-bold mb-4" style={{ color: 'black' }}>
            Başkan Mesajı
          </h2>
          <div className="line-height-3 text-justify" dangerouslySetInnerHTML={{ __html: message }} />
        </Card> */}
      <Card >
        <div
          className="preview-content"
          dangerouslySetInnerHTML={{ __html: content }}

          style={{
            padding: "1rem",
            backgroundColor: "white",
            borderRadius: "4px",
            minHeight: "200px"
          }}
        />
      </Card>
    </div>
  );
};

export default BaskanMesaj;
